import Application from "../../Application";
import Area, { IArea } from "../../core/areas/Area";
import { IRouter } from "../../runtime/Router";
import CreateCaseDecisionTypeInteractor from "../interactor/CreateCaseDecisionTypeInteractor";
import GetAllCaseDecisionTypesInteractor from "../interactor/GetAllCaseDecisionTypesInteractor";
import GetCaseDecisionTypeIndexDataInteractor from "../interactor/GetCaseDecisionTypeIndexDataInteractor";
import ShowCaseDecisionTypesInteractor from "../interactor/ShowCaseDecisionTypesInteractor";
import UpdateCaseDecisionTypeInteractor from "../interactor/UpdateCaseDecisionTypeInteractor";
import CreateCaseDecisionInteractor from "../interactor/CreateCaseDecisionInteractor";
import GetAllCaseDecisionsInteractor from "../interactor/GetAllCaseDecisionsInteractor";
import FindCaseDecisionInteractor from "../interactor/FindCaseDecisionInteractor";
import ShowCaseDecisionsInteractor from "../interactor/ShowCaseDecisionsInteractor";
import UpdateCaseDecisionInteractor from "../interactor/UpdateCaseDecisionInteractor";
import GetAttachmentsForCaseDecisionInteractor from "../interactor/GetAttachmentsForCaseDecisionInteractor";
import RemoveCaseDecisionAttachmentInteractor from "../interactor/RemoveCaseDecisionAttachmentInteractor";
import CaseDecisionPage from "../ui/pages/CaseDecisionPage";
import CaseDecisionTypesPage from "../ui/pages/CaseDecisionTypesPage";
import CaseDecisionDetailsPage from "../ui/pages/CaseDecisionDetailsPage";
import CaseDecisionCreationPage from "../ui/pages/CaseDecisionCreationPage";
import ShowCaseDecisionDetailsInteractor from "../interactor/ShowCaseDecisionDetailsInteractor";
import GetCaseDecisionIndexesInteractor from "../interactor/GetCaseDecisionIndexesInteractor";
import ShowCaseDecisionUpdateInteractor from "../interactor/ShowCaseDecisionUpdateInteractor";
import CaseDecisionUpdatePage from "../ui/pages/CaseDecisionUpdatePage";
import ArchiveCaseDecisionInteractor from "../interactor/ArchiveCaseDecisionInteractor";
import FindCourtCaseDetailsForCaseDecisionInteractor from "../../caseLawDocuments/interactor/FindCourtCaseDetailsForCaseDecisionInteractor";
import RemoveLegalViewAttachmentInteractor from "../../legalViews/interactor/RemoveLegalViewAttachmentInteractor";
import ShowCaseDecisionCreationInteractor from "../interactor/ShowCaseDecisionCreationInteractor";
import RemoveCaseDecisionInteractor from "../interactor/RemoveCaseDecisionInteractor";
import FindDecisionIndexesInCategoryInteractor from "../interactor/FindDecisionIndexesInCategoryInteractor";
import PublishCaseDecisionInteractor from "../interactor/PublishCaseDecisionInteractor";
import GetInvalidatedCaseDecisionsInteractor from "../interactor/GetInvalidatedCaseDecisionsInteractor";
import RevertCaseDecisionStatusInteractor from "../interactor/RevertCaseDecisionStatusInteractor";

export default class CaseDecisionsArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor({
    application,
    router
  }: {
    application: Application;
    router: IRouter;
  }) {
    super();
    this.application = application;
    this.router = router;
  }
  private registerModules() {
    const container = this.application.container;
    container.registerInteractor(
      "createCaseDecision",
      CreateCaseDecisionInteractor
    );
    container.registerInteractor(
      "findCaseDecision",
      FindCaseDecisionInteractor
    );
    container.registerInteractor(
      "getAllCaseDecisions",
      GetAllCaseDecisionsInteractor
    );
    container.registerInteractor(
      "updateCaseDecision",
      UpdateCaseDecisionInteractor
    );
    container.registerInteractor(
      "showCaseDecisions",
      ShowCaseDecisionsInteractor
    );
    container.registerInteractor(
      "showCaseDecisionTypes",
      ShowCaseDecisionTypesInteractor
    );
    container.registerInteractor(
      "updateCaseDecisionType",
      UpdateCaseDecisionTypeInteractor
    );
    container.registerInteractor(
      "getAllCaseDecisionTypes",
      GetAllCaseDecisionTypesInteractor
    );
    container.registerInteractor(
      "createCaseDecisionType",
      CreateCaseDecisionTypeInteractor
    );
    container.registerInteractor(
      "getCaseDecisionTypeIndexData",
      GetCaseDecisionTypeIndexDataInteractor
    );
    container.registerInteractor(
      "getAttachmentsForCaseDecision",
      GetAttachmentsForCaseDecisionInteractor
    );
    container.registerInteractor(
      "showCaseDecisionDetails",
      ShowCaseDecisionDetailsInteractor
    );
    container.registerInteractor(
      "removeCaseDecisionAttachment",
      RemoveCaseDecisionAttachmentInteractor
    );
    container.registerInteractor(
      "getCaseDecisionIndexes",
      GetCaseDecisionIndexesInteractor
    );
    container.registerInteractor(
      "ShowCaseDecisionUpdate",
      ShowCaseDecisionUpdateInteractor
    );
    container.registerInteractor(
      "archiveCaseDecision",
      ArchiveCaseDecisionInteractor
    );
    container.registerInteractor(
      "findCourtCaseDetailsForCaseDecision",
      FindCourtCaseDetailsForCaseDecisionInteractor
    );
    container.registerInteractor(
      "removeLegalViewAttachment",
      RemoveLegalViewAttachmentInteractor
    );
    container.registerInteractor(
      "showCaseDecisionCreation",
      ShowCaseDecisionCreationInteractor
    );
    container.registerInteractor(
      "removeCaseDecision",
      RemoveCaseDecisionInteractor
    );
    container.registerInteractor(
      "findDecisionIndexesInCategory",
      FindDecisionIndexesInCategoryInteractor
    );
    container.registerInteractor(
      "publishCaseDecision",
      PublishCaseDecisionInteractor
    );
    container.registerInteractor(
      "getInvalidatedCaseDecisions",
      GetInvalidatedCaseDecisionsInteractor
    );
    container.registerInteractor(
      "revertCaseDecisionStatus",
      RevertCaseDecisionStatusInteractor
    );
  }
  register(params: any) {
    this.registerModules();
    this.router.registerRoutes(
      {
        path: "/case-decisions",
        page: this.createPage({
          Page: CaseDecisionPage,
          action: this.showCaseDecisionPage.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/case-decisions/:id/details",
        page: this.createPage({
          Page: CaseDecisionDetailsPage,
          action: this.showCaseDecisionDetailsPage.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/case-decisions/new",
        page: this.createPage({
          Page: CaseDecisionCreationPage,
          action: this.showCaseDecisionCreationPage.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/case-decisions/new/:caseNumber",
        page: this.createPage({
          Page: CaseDecisionCreationPage,
          action: this.showCaseDecisionCreationPageWithId.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/case-decisions/:id/update",
        page: this.createPage({
          Page: CaseDecisionUpdatePage,
          action: this.showCaseDecisionUpdatePage.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/case-decision-types",
        page: this.createPage({
          Page: CaseDecisionTypesPage,
          action: this.showCaseDecisionTypesPage.bind(this)
        }),
        options: {
          secure: false
        }
      }
    );
  }
  public showCaseDecisionDetailsPage({ id }: { id: string }) {
    return this.application.container
      .resolve<ShowCaseDecisionDetailsInteractor>("showCaseDecisionDetails")
      .execute(id);
  }
  public showCaseDecisionCreationPage() {
    return this.application.container
      .resolve<ShowCaseDecisionCreationInteractor>("showCaseDecisionCreation")
      .execute();
  }
  public showCaseDecisionCreationPageWithId({
    caseNumber
  }: {
    caseNumber: string;
  }) {
    return this.application.container
      .resolve<ShowCaseDecisionCreationInteractor>("showCaseDecisionCreation")
      .execute(caseNumber);
  }
  public showCaseDecisionUpdatePage({ id }: { id: string }) {
    return this.application.container
      .resolve<ShowCaseDecisionUpdateInteractor>("ShowCaseDecisionUpdate")
      .execute(id);
  }
  public showCaseDecisionTypesPage() {
    return this.application.container
      .resolve<ShowCaseDecisionTypesInteractor>("showCaseDecisionTypes")
      .execute();
  }
  public showCaseDecisionPage() {
    return this.application.container
      .resolve<ShowCaseDecisionsInteractor>("showCaseDecisions")
      .execute();
  }
}
